document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".newsletter-modal-wrapper");
  if (!popup) return;

  const closeBtn = popup.querySelector(".newsletter-modal-close");
  const delay = parseInt(popup.dataset.delay) || 5000;

  const SUBSCRIBED_KEY = "newsletterSubscribed";

  const showPopup = () => {
    if (!localStorage.getItem(SUBSCRIBED_KEY)) {
      popup.classList.add("active");
    }
  };

  const hidePopup = () => {
    popup.classList.remove("active");
  };

  if (closeBtn) {
    closeBtn.addEventListener("click", hidePopup);
  }

  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      hidePopup();
    }
  });

  const params = new URLSearchParams(window.location.search);
  if (params.get("customer_posted") === "true") {
    localStorage.setItem(SUBSCRIBED_KEY, "true");
    popup.classList.add("success", "active");

    window.history.replaceState({}, document.title, window.location.pathname);
    return;
  }

  if (!localStorage.getItem(SUBSCRIBED_KEY)) {
    setTimeout(showPopup, delay);
  }
});

// ?customer_posted=true
